import { QueryStatus } from "@reduxjs/toolkit/query";
import { sensitiveDataApis } from "apis/sensitiveData";
import { Spinner } from "components/DesignSystem/Loader/loader";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { EntitySelector } from "./EntitySelector";

export const EntityTopBar = () => {
  const { entityId } = useParams<{ entityId: string }>();

  const selectSensitiveData = useMemo(
    () => sensitiveDataApis.endpoints.getAllSensitiveData.select({ entityId }),
    [entityId]
  );

  const { status, data } = useSelector(selectSensitiveData);
  const isRefreshing = status === QueryStatus.pending && Boolean(data);

  return (
    <div className="t-sticky t-top-0 t-z-filter-head t-flex t-items-center t-gap-3 t-bg-surface t-pb-3">
      <span className="t-text-body t-text-text-30 t-whitespace-nowrap">
        Showing for entity:
      </span>
      <EntitySelector />
      {isRefreshing && (
        <span className="t-ml-auto t-flex t-items-center">
          <Spinner size="small" />
        </span>
      )}
    </div>
  );
};
